import { render } from "./Complains.vue?vue&type=template&id=b3ad129a&scoped=true"
import script from "./Complains.vue?vue&type=script&lang=js"
export * from "./Complains.vue?vue&type=script&lang=js"

import "./Complains.vue?vue&type=style&index=0&id=b3ad129a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b3ad129a"

export default script